import { createSelector } from "reselect";

/**
 * selector to determine if users csv export is enabled on admin tab
 */
export const usersCsvExportEnabledSelector = createSelector(() => true);
